import { LoginRequest, TokenPair } from "@virtualprogaming/js-auth-sdk";
import { isFunction } from "lodash-es";
import { useCallback } from "react";
import { useMutation, UseMutationOptions } from "react-query";

import { useAuthApi, useSetAuthTokens } from "~/utils";

export function useLogin(
  options?: UseMutationOptions<TokenPair, unknown, LoginRequest>
) {
  const api = useAuthApi();
  const setAuthTokens = useSetAuthTokens();
  const { onSuccess, ...restOptions } = options || {};
  return useMutation(
    async (request: LoginRequest) => {
      const { data } = await api.login(request);
      return data;
    },
    {
      onSuccess: async (res, data, ctx) => {
        setAuthTokens(res);
        isFunction(onSuccess) && onSuccess(res, data, ctx);
      },
      ...restOptions,
    }
  );
}

export function useLogout() {
  const setTokens = useSetAuthTokens();
  return useCallback(() => {
    setTokens({});
    window.location.replace("/");
  }, [setTokens]);
}
